webpackJsonp([73],{

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1379);


/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(212);

var _datetime2 = _interopRequireDefault(_datetime);

var _it = __webpack_require__(854);

var _it2 = _interopRequireDefault(_it);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('it', _it2.default);

/***/ })

},[1378]);


// WEBPACK FOOTER //
// app/datetime.it-2fea91665cdba220d068.js